import { yupResolver } from '@hookform/resolvers/yup'
import { useEffect } from 'react'
import { Controller, useForm } from 'react-hook-form'
import type { Resolver } from 'react-hook-form/dist/types'
import * as yup from 'yup'

import { Divider, Toggle } from '../../common/designs'
import { useEnhancedSearchParams } from '../../common/hooks'
import { SubSearchParamEnum } from '../../common/types/searchParams'
import useBusinessAppsFilters from './useBusinessAppsFilters'

const formSchema = yup.object().shape({
  isIgnoreWeekendsActive: yup.boolean(),
})

interface Inputs {
  isIgnoreWeekendsActive: boolean
}

const FlowFilters = () => {
  const { isIgnoreWeekendsActive } = useBusinessAppsFilters()
  const { updateSearchParam } = useEnhancedSearchParams()

  const { control, watch } = useForm<Inputs>({
    resolver: yupResolver(formSchema) as Resolver<Inputs>,
    defaultValues: { isIgnoreWeekendsActive },
  })

  useEffect(() => {
    watch((data) => {
      updateSearchParam(
        SubSearchParamEnum.IGNORE_WEEKENDS,
        (data.isIgnoreWeekendsActive ?? false).toString(),
      )
    })
  }, [watch, updateSearchParam])

  return (
    <form autoComplete='off' className='space-y-4'>
      <Controller
        name='isIgnoreWeekendsActive'
        control={control}
        render={({ field: { value, onChange } }) => (
          <Toggle value={value} onChange={onChange} label='Ignore weekends' />
        )}
      />

      <Divider className='-mx-6 w-128' />
    </form>
  )
}

export default FlowFilters

